// extracted by mini-css-extract-plugin
export default {"group-list":"GenAICleanupRequiredDialog_group-list__VtRpw"};